import React from 'react';
import '../style/LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner">
      <div className="loading-circle w-8 h-8"></div>
    </div>
  );
};

export default LoadingSpinner;
